define.alias("checkout/components/seamless-checkout/checkout-variant-modal", "calendar/components/seamless-checkout/checkout-variant-modal");